/**
 * @author annie
 * The modal dialog controller developed explicitely for the overlays. It will mostly listen to the events from other controllers when they were broadcast.
 * And do appropriate actions.
 */

var appCtrlModalsModule = angular.module('AppCtrl.modals', ['AppCtrl.contact.service', 'AppCtrl.ContactDetails.service', 'jv.Common.Directives.Datepicker', 'jv.source.modal-adapter.service']);
appCtrlModalsModule.directive('jvModalSelect2', function ($timeout) {

    var linker = function (scope, element, attribute) {

        var hiddenField = angular.element("<input style='" + attribute['style'] + "' type=\"hidden\" />");
        element.append(hiddenField);
        var firstRun = true;

        function buildResetObj() {
            var resetObj = {};
            if (angular.isDefined(attribute.jvPlaceholder)) {
                resetObj[attribute.whatIsId] = '';
                resetObj[attribute.whatIsText] = attribute.jvPlaceholder;
            } else {
                if (firstRun && scope.whatToChange != null && angular.isDefined(scope.whatToChange)) {
                    resetObj = scope.whatToChange;
                } else {
                    resetObj = scope.whatToWatch[0];
                }
                firstRun = false;
            }
            return resetObj;
        }

        function renderSelect2() {
            // If there is another way you want to show the text.
            function format(item) {
                return item[attribute['whatIsText']];
            }

            var options = angular.copy(window._jvPluginDefaults.select2) || {};
            if (angular.isDefined(attribute.jvPlaceholder)) {
                options.allowClear = !!attribute.jvAllowClear;
            }
            if (angular.isDefined(attribute.jvPlaceholder)) {
                options.placeholder = attribute.jvPlaceholder;
            }

            options.formatSelection = format;
            options.formatResult = format;
            options.id = function (state) {
                return state[attribute['whatIsId']] || state['id'];
            };
            options.data = {
                results: scope['whatToWatch'],
                text: attribute['whatIsText']
            };
            options.initSelection = function (element, callback) {
                if (angular.isObject(scope.whatToChange)) {
                    callback(scope.whatToChange);
                } else if (angular.isUndefined(attribute.jvPlaceholder)) {
                    callback(scope.whatToWatch[0]);
                }
            };

            $(hiddenField).select2(options).on('change', function (event) {
                scope.$apply(function (scope) {
                    if (event.val === '' || angular.isUndefined(scope.whatToChange) || scope.whatToChange == null) {
                        scope.whatToChange = buildResetObj();
                    } else {
                        for (var i = 0, j = scope['whatToWatch'].length; i < j; i++) {
                            if (scope['whatToWatch'][i][attribute['whatIsId']] === event.val) {
                                scope['whatToChange'] = scope['whatToWatch'][i];
                                break;
                            }
                        }
                    }
                });
            });

            // use time out for setting the value so you know that apply will always be applied.
            $timeout(function () {
                // set the initial value as the first one in the result list. Below doesnt work.
                //https://github.com/ivaynberg/select2/issues/49
                var newVal = buildResetObj();
                $(hiddenField).val(newVal);
                $(hiddenField).trigger('change');
            }, 300);

            if (scope['setToDisabled'] === 'true') {
                $(hiddenField).select2('disable');
            }
        }

        scope.$watch('whatToWatch', function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue.length > 0) {
                renderSelect2();
            }
        });
    };

    return {
        restrict: 'A',
        scope: {
            'whatToWatch': '=whatToWatch',
            'whatToChange': '=whatToChange',
            'whatIsText': '@whatIsText',
            'whatIsId': '@whatIsId',
            'setToDisabled': '@'
        },
        link: linker
    };
});
appCtrlModalsModule.value('MODAL_CONST', {
    strings: {
        'EMAILS_CONFIRMATION': i18n['JV_CONTACTMODAL_EMAILS_SCHEDULED_FOR_CAMPAIGN_']
    },
    // template actions. HTMS
    Urls: {
        'selectRequisitions': window.jvUrls.source + '/htm/contact2/modals/addRequisition.html',
        'selectEmailCampaign': window.jvUrls.source + '/htm/contact2/modals/addCampaign.html',
        'addTag': window.jvUrls.source + '/htm/contact2/modals/addTag.html',
        'addNote': window.jvUrls.source + '/htm/contact2/modals/addNote.html',
        'addMessage': window.jvUrls.source + '/htm/contact2/modals/addMessage.html',
        'seekConsent': window.jvUrls.source + '/htm/contact2/modals/listSeekConsent.html',
        'reqConfirmation': window.jvUrls.source + '/htm/contact2/modals/reqConfirmation.html',
        'saveSearch': window.jvUrls.source + '/htm/contact2/modals/saveSearch.html',
        'importContacts': window.jvUrls.source + '/htm/contact2/modals/importContacts.html',
        'selectSavedSearch': window.jvUrls.source + '/htm/contact2/modals/selectSavedSearch.html',
        'deleteContacts': window.jvUrls.source + '/htm/contact2/modals/deleteContacts.html',
        'advancedSettings': window.jvUrls.source + '/htm/contact2/modals/advancedSettings.html',
        'assignTo': window.jvUrls.source + '/htm/contact2/modals/assignTo.html',
        'changeStatus': window.jvUrls.source + '/htm/contact2/modals/changeStatus.html',
        'addTask': window.jvUrls.source + '/htm/contact2/modals/addTask.html',
        'addToReq': window.jvUrls.source + '/htm/contact2/modals/addToReq.html'
    },

    // Action users. AJAX
    actionUrls: {
        getRequisitions: window.jvUrls.jhire + '/action/requisitionList',
        getWebCampaigns: window.jvUrls.jhire + '/action/campaignList',
        selectCampaign: window.jvUrls.source + '/action/person/contactList',
        getMessageInfo: window.jvUrls.source + '/action/crm/facetedsearch/messageinfo',
        saveTags: window.jvUrls.source + '/action/person/contactList',
        importContacts: window.jvUrls.source + '/action/crm/contactaction',
        getSavedSearchList: window.jvUrls.source + '/action/crm/facetedsearch/savedsearch', //HTTP GET; HTTP GET param: searchName for search 
        getSavedSearch: window.jvUrls.source + '/action/crm/facetedsearch/savedsearch/{0}', //HTTP GET; HTTP POST param: searchName for rename; HTTP DELETE for delete
        deleteContacts: window.jvUrls.source + '/action/crm/facetedsearch/contacts/delete', //HTTP POST?
        deleteContactsPII: window.jvUrls.source + '/action/crm/facetedsearch/contacts/delete?anonymizeOnly=true',
        contacts: window.jvUrls.source + '/action/crm/contacts',
        tasks: window.jvUrls.source + '/action/tasks',
        settings: window.jvUrls.admin + '/action/admin/configuration?'
    }
});
appCtrlModalsModule.filter('statusPrint', function () {
    return function (status) {
        if (status === 'IN_PROGRESS') {
            return i18n['JV_CONTACTMODAL_ACTIVE'];
        } else {
            return i18n['JV_CONTACTMODAL_INACTIVE'];
        }
    };
});

/**
 * Service for modal dialogs to perform actions on these modals.
 * @param {Object} MODAL_CONST
 * @param {Object} makeAjaxCall
 */
appCtrlModalsModule.service('actionModalService', ['MODAL_CONST', 'makeAjaxCall', 'contactService', '$http', function (MODAL_CONST, makeAjaxCall, contactService, $http) {
    var actionModalService = {};

    actionModalService.getRequisition = function (args, callback) {
        var requestObj = args || {};
        callback = (callback || angular.noop);
        args.maxResults = 10;
        // which page to get.
        args.page = args.page ? args.page : 0;
        requestObj['ajaxtype'] = 'getRequisitionsAction';
        requestObj['url'] = MODAL_CONST.actionUrls.getRequisitions;
        requestObj['requestType'] = 'GET';
        var _getRequisitions = makeAjaxCall(requestObj);
        _getRequisitions.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.getSavedSearchList = function (args, callback) {
        var requestObj = {};
        callback = (callback || angular.noop);

        requestObj['ajaxtype'] = 'getSavedSearchListAction';
        requestObj['url'] = MODAL_CONST.actionUrls.getSavedSearchList;
        requestObj['requestType'] = 'GET';
        if (args !== null && args !== '' && args !== undefined) {
            requestObj['searchName'] = args;
        }
        var _getSavedSearchList = makeAjaxCall(requestObj);
        _getSavedSearchList.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.getSavedSearch = function (args, callback) {
        var requestObj = {};
        callback = (callback || angular.noop);

        requestObj['ajaxtype'] = 'getSavedSearchAction';
        requestObj['url'] = MODAL_CONST.actionUrls.getSavedSearch.format(args.Eid);
        requestObj['requestType'] = args.type; //GET, POST, DELETE
        if (args.searchName !== null && args.searchName !== '' && args.searchName !== undefined) {
            requestObj['searchName'] = args.searchName;
        }
        var _getSavedSearch = makeAjaxCall(requestObj);
        _getSavedSearch.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.getMessageInfo = function (args, includeMessageTemplatesFlag, resourceTypeId, callback) {
        var requestObj = {};
        callback = (callback || angular.noop);
        requestObj.ids = args;
        requestObj.includeMessageTemplates = includeMessageTemplatesFlag;
        requestObj.resourceTypeId = resourceTypeId;

        requestObj['ajaxtype'] = 'getMessageInfo';
        requestObj['url'] = MODAL_CONST.actionUrls.getMessageInfo;
        requestObj['requestType'] = 'GET';
        var _getMessages = makeAjaxCall(requestObj);
        _getMessages.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.saveTags = function (args, callback) {
        callback = (callback || angular.noop);
        const _contactSaveTags = args || {};
        _contactSaveTags['url'] = MODAL_CONST.actionUrls.saveTags;
        _contactSaveTags['ajaxtype'] = 'saveContactTags';
        _contactSaveTags['requestType'] = 'POST';
        var _saveTags = makeAjaxCall(_contactSaveTags);
        _saveTags.then(function (results) {
            callback(results.data);
        }, function (error) {
            window.JV.showDropDownMessageError(i18n['JV_CONTACTMODAL_UNABLE_TO_ADD_TAGS_TO_CONTACTS_']);
        });
    };

    actionModalService.importContacts = function (args, callback) {
        callback = (callback || angular.noop);
        const _contactSaveTags = args || {};
        _contactSaveTags['url'] = MODAL_CONST.actionUrls.importContacts;
        _contactSaveTags['ajaxtype'] = args.ajaxtype ? args.ajaxtype : 'importContacts';
        _contactSaveTags['requestType'] = 'POST';
        var _saveTags = makeAjaxCall(_contactSaveTags);
        _saveTags.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.deleteContacts = function (args, callback) {
        callback = (callback || angular.noop);
        const _contactDeleteObject = args || {};
        _contactDeleteObject['url'] = MODAL_CONST.actionUrls.deleteContacts;
        _contactDeleteObject['ajaxtype'] = 'deleteContacts';
        _contactDeleteObject['requestType'] = 'POST';
        var _deleteContact = makeAjaxCall(_contactDeleteObject);
        _deleteContact.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.deleteContactsPII = function (args, callback) {
        callback = (callback || angular.noop);
        const _contactDeleteObject = args || {};
        _contactDeleteObject['url'] = MODAL_CONST.actionUrls.deleteContactsPII;
        _contactDeleteObject['ajaxtype'] = 'deleteContactsPII';
        _contactDeleteObject['requestType'] = 'POST';
        var _deleteContact = makeAjaxCall(_contactDeleteObject);
        _deleteContact.then(function (results) {
            callback(results.data);
        });
    };

    actionModalService.assignTo = function (contacts, employee) {
        return $http.post(MODAL_CONST.actionUrls.contacts, {
            contactEIds: contacts,
            fieldName: 'assignedTo',
            fieldValue: employee
        });
    };

    actionModalService.changeStatus = function (contacts, status) {
        return $http.post(MODAL_CONST.actionUrls.contacts, {
            contactEIds: contacts,
            fieldName: 'status',
            fieldValue: status
        });
    };

    actionModalService.addTask = function (contacts, task) {
        return $http.post(MODAL_CONST.actionUrls.tasks, {
            entityEIds: contacts,
            entityTask: task
        });
    };

    actionModalService.getTagsLocked = function (callback) {
        var data = {
            properties: 'TAGS_LOCKED'
        };

        $http.get(MODAL_CONST.actionUrls.settings + $.param(data)).success(function (res) {
            var result = res.configProperties[0].enabled;
            callback(res);
        });
    };

    return actionModalService;
}]);

/**
 * Service is used only to get the static htm templates from the backend.
 * @param {Object} MODAL_CONST
 * @param {Object} makeAjaxCall
 * @param {Object} $compile
 */
appCtrlModalsModule.service('modalService', ['MODAL_CONST', 'makeAjaxCall', '$compile', 'sourceModalAdapter', function (MODAL_CONST, makeAjaxCall, $compile, sourceModalAdapter) {
    var modalService = {};

    window.JV.initializeModal();

    /**
     * Utility for making ajax calls on behalf of the modal services.Each call gets the template from the backend and triggers the corresponding controller and show the overlay.
     * @param {String} _url: Url where it should query for the templates.
     * @param {String} _controllerName: What is the controller name that should be triggered.
     * @param {String} _ajaxType: define the name of the ajax type which will be shown in the google analytics.
     * @param {Object} resultObjectToPassToController(Optional): Object required by the controller to render the information in the modal dialog. If passed this will become 
     *                                                          part of the 'results' property for the modal controller.
     * @param {serviceObject} : (optional) deferred Object, if passed will be available to the modal controller scope's "deferred" key. Its like a callback for the parent controller that is calling the modal.
     */
    function getModalAndTriggerController(_url, _controllerName, _ajaxType, resultObjectToPassToController, deferredService) {
        var requestObj = {
            url: _url,
            ajaxtype: _ajaxType,
            requestType: 'GET'
        };

        // get the template
        var _getModal = makeAjaxCall(requestObj);
        _getModal.then(function (results) {
            results = results.data;
            sourceModalAdapter.injectContentsInModal(results);
            var _element = angular.element('div[ng-controller="' + _controllerName + '"]');
            var _scope = _element.scope();
            $compile(_element)(_scope);
            _scope = _element.scope();
            // every modal controller will get the 'results' property by default which will be necessary to render the information.
            if (typeof resultObjectToPassToController === 'object' || (resultObjectToPassToController && resultObjectToPassToController.trim() !== '')) {
                _scope.results = resultObjectToPassToController;
            } else {
                _scope.results = {};
            }
            // adding the defferred service property
            if (deferredService && deferredService.trim() !== '') {
                _scope.deferredService = deferredService;
            }

            // Show the modal now.
            sourceModalAdapter.showModal();
        });

    }

    // Get the modal for selecting the requistions from the modal
    modalService.selectRequisition = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectRequisitions, 'SelectRequisitionsController', 'selectRequsitionOverlay', results);
    };

    // Get the modal for selecting the requistions from the modal
    modalService.selectCampaign = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectEmailCampaign, 'selectEmailCampaignsController', 'selectTypeOfCampaignOverlay', results);
    };
    modalService.addNote = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.addNote, 'addNoteController', 'addNoteOverlay', results);
    };

    modalService.saveSearch = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.saveSearch, 'saveSearchController', 'saveSearchOverlay', results);
    };

    modalService.importContacts = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.importContacts, 'importContactsController', 'importContactsOverlay', results);
    };

    modalService.addTag = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.addTag, 'addTagController', 'addTagOverlay', results);
    };

    modalService.addMessage = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.addMessage, 'addMessageController', 'addMessageOverlay', results);
    };

    modalService.addSeekConsentMessage = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.seekConsent, 'addSeekConsentMessageController', 'addMessageOverlay', results);
    };

    modalService.addtoReqConfirm = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.reqConfirmation, 'reqConfirmationController', 'reqConfirmationOverlay', results);
    };

    modalService.selectSavedSearch = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.selectSavedSearch, 'selectSavedSearchController', 'selectSavedSearchOverlay', results);
    };

    modalService.deleteContacts = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.deleteContacts, 'deleteContactsController', 'deleteContactsOverlay', results);
    };

    modalService.deleteContactsPII = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.deleteContacts, 'deleteContactsController', 'deleteContactsOverlay', results);
    };

    modalService.advancedSettings = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.advancedSettings, 'advancedSettingsController', 'advancedSettingsOverlay', results);
    };

    modalService.assignTo = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.assignTo, 'assignToController', 'assignToOverlay', results);
    };

    modalService.changeStatus = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.changeStatus, 'changeStatusController', 'changeStatusOverlay', results);
    };

    modalService.addTask = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.addTask, 'addTaskController', 'addTaskOverlay', results);
    };

    modalService.addToReq = function (results) {
        getModalAndTriggerController(MODAL_CONST.Urls.addToReq, 'addToReqController', 'addToReqOverlay', results);
    };

    return modalService;
}]);

/**
 * CONTROLLERS
 * Main modals controller. All the controllers are extending this controller. So put the common functionality here.
 * @param {Object} $scope
 */
appCtrlModalsModule.controller('ModalsParentCtrl', ['$scope', 'sourceModalAdapter',
    function ($scope, sourceModalAdapter) {
        // close the overlay
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            this.$destroy();
        };
    }
]);

/**
 * saveSearch modal
 */
appCtrlModalsModule.controller('saveSearchController', ['$scope', '$rootScope', 'contactService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };
        $scope.save = function () {
            //TODO: Error checking - if name is null
            $rootScope.$broadcast('saveSearch', $scope.searchName);
            $scope.close();
        };

    }
]);

/**
 * selectSavedSearch modal
 */
appCtrlModalsModule.controller('selectSavedSearchController', ['$scope', '$rootScope', 'contactService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, actionModalService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };

        function getSearchModal() {
            $scope.showLoading = true;
            // Below two properties are needed by the jhire backend to not consider cookie values saved on the req pages.
            actionModalService.getSavedSearchList($scope.query, function (results) {
                $scope.results = results;
                $scope.showLoading = false;
                $scope.selected = undefined;
            });
        }

        getSearchModal();


        $scope.search = function () {
            $scope.query = $scope.searchNameQuery;
            getSearchModal();
        };

        $scope.clearSearch = function () {
            $scope.query = undefined;
            $scope.searchNameQuery = undefined;
            getSearchModal();
        };

        $scope.editName = function (searchObj) {
            searchObj.editing = !searchObj.editing;
            searchObj.editName = searchObj.searchName;
            searchObj.index = true;
        };

        $scope.rename = function (searchObj) {
            $scope.args = {}
            $scope.args.type = 'POST';
            $scope.args.searchName = searchObj.editName;
            $scope.args.Eid = searchObj.EId;

            actionModalService.getSavedSearch($scope.args, function () {
                getSearchModal();
            });
        };

        $scope.deleteSearch = function (EId) {
            $scope.args = {}
            $scope.args.type = 'DELETE';
            $scope.args.Eid = EId;

            actionModalService.getSavedSearch($scope.args, function () {
                getSearchModal();
            });
        };

        $scope.select = function (EId) {
            $scope.selected = EId;
            $scope.error = false;
        };

        $scope.save = function () {
            if (!$scope.selected) {
                $scope.error = true;
            } else {
                $scope.args = {}
                $scope.args.type = 'GET';
                $scope.args.Eid = $scope.selected;

                actionModalService.getSavedSearch($scope.args, function (results) {
                    $rootScope.$broadcast('selectSearch', results.searchUrl);
                    $scope.close();
                });
            }
        };
    }
]);

/**
 * import contacts modal
 */
appCtrlModalsModule.controller('importContactsController', ['$scope', '$rootScope', 'contactService', 'contactDetailsService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, contactDetailsService, actionModalService, sourceModalAdapter) {
        $scope.importDuplicatesCheck = '1';
        $scope.close = function () {
            $('#jv-selectCampaign').select2('close');
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        //Select2Service
        $scope.autoComplete = function (categoryId) {
            var config = {
                id: 'EId',
                ajax: {
                    url: window.jvUrls.source + '/action/crm/campaigns/list',
                    data: function (term) {
                        return {
                            type: 'EMAIL',
                            status: 'IN_PROGRESS',
                            page: 0,
                            hasContentFlag: false,
                            maxResults: 10000,
                            keywords: term
                        };
                    },
                    results: function (data) {
                        return {
                            results: data.resultList
                        };
                    }
                },
                formatResult: function (data) {
                    return data.name;

                },
                formatSelection: function (data) {
                    $scope.campaignId = data.eid;
                    return data.name;

                },
                id: function (data) {
                    return data.eid;
                }
            };
            return config;
        };

        $scope.save = function () {
            var args = {
                'action': 'import',
                'sessionGUID': window.JV.ContactImport.getGUID()
            };

            var urls = $('#jv-targetUrls').val().split('\n').join(',');
            if (urls.length > 0) args['urls'] = urls;
            if ($scope.tags) {

                var _tags = [];

                // extract the text of each tag
                $.each($scope.tags, function (index, value) {
                    _tags.push(value.name);
                });

                args['tags'] = _tags.join(',');
            }
            if ($scope.notes) {
                args['notes'] = $scope.notes;
            }

            if ($scope.campaignId) {
                args['campaignId'] = $scope.campaignId;
            }
            switch ($scope.importDuplicatesCheck) {
                case '1':
                    args['importDuplicates'] = false;
                    args['mergeDuplicates'] = true;
                    args['ajaxtype'] = 'importContacts_mergeContacts';
                    break;
                case '2':
                    args['importDuplicates'] = true;
                    args['mergeDuplicates'] = false;
                    args['ajaxtype'] = 'importContacts_createDups';
                    break;
                case '3':
                    args['importDuplicates'] = false;
                    args['mergeDuplicates'] = false;
                    args['ajaxtype'] = 'importContacts_skipDups';
                    break;
                default:
                    // default
            }

            var _callback = function (result) {
                $scope.close();
                if (result.result.indexOf('success') !== -1) {
                    window.JV.showDropDownMessage(i18n['JV_CONTACTMODAL_CONTACT_IMPORT_STARTED'])
                } else {
                    window.JV.showDropDownMessageError(i18n['JV_CONTACTMODAL_IMPORT_ERROR_'])
                }
            };

            actionModalService.importContacts(
                args, _callback);
            $scope.close();
        };

        $scope.tagSelect = contactDetailsService.tagSelect;
    }
]);

/**
 * delete contacts modal
 */
appCtrlModalsModule.controller('deleteContactsController', ['$scope', '$rootScope', 'actionModalService', 'contactService', 'sourceModalAdapter',
    function ($scope, $rootScope, actionModalService, contactService, sourceModalAdapter) {
        $scope.deleteCount = contactService.deleteEids.length;
        $scope.isGDPREnabled = window.JV.gdprEnabled;
        $scope.deleteAnonymize = 'anonymizeContact';
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        $scope.save = function () {
            var _callback = function (result) {
                window.JV.removeFullPageLoading();
                $scope.close();
                if (result.status === 'ok' && $scope.isGDPREnabled === 'false') {
                    window.JV.showDropDownMessage(i18n['JV_CONTACTMODAL_CONTACT_S_HAVE_BEEN_DELETED_']);
                } else if (result.status === 'ok' && $scope.isGDPREnabled === 'true') {

                    if ($scope.deleteAnonymize === 'anonymizeContact') {
                        window.JV.showDropDownMessage(i18n['I18N_SELECT_PERSONAL_IDENTIFIABLE_INFORMATION']);
                    } else {
                        window.JV.showDropDownMessage(i18n['JV_CONTACTMODAL_CONTACT_S_HAVE_BEEN_DELETED_']);
                    }
                } else {
                    window.JV.showDropDownMessageError(i18n['JV_CONTACTMODAL_UNABLE_TO_DELETE_CONTACT_S_']);
                }
            };

            if ($scope.isGDPREnabled && $scope.deleteAnonymize === 'anonymizeContact') {
                //Need to add page loading image
                actionModalService.deleteContactsPII({
                    'ids': contactService.deleteEids,
                }, _callback);
            } else {
                actionModalService.deleteContacts({
                    'ids': contactService.deleteEids,
                }, _callback);
            }
        };
    }
]);

/**
 * note modal
 */
appCtrlModalsModule.controller('addNoteController', ['$scope', '$rootScope', 'contactService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };
        $scope.save = function () {
            $scope.error = ($scope.noteContent === '' || $scope.noteContent == null);
            if (!$scope.error) {
                $rootScope.$broadcast('addNote', $scope.noteContent);
                $scope.close();
            }
        };
    }
]);

/**
 * tag modal
 */
appCtrlModalsModule.controller('addTagController', ['$scope', '$rootScope', 'contactDetailsService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactDetailsService, actionModalService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };
        $scope.tags = [];

        $scope.save = function () {

            var _callback = function (result) {
                $scope.close();
                window.JV.showDropDownMessage(result);
            };

            var _tags = [];

            // extract the text of each tag
            $.each($scope.tags, function (index, value) {
                _tags.push(value.name);
            });

            actionModalService.saveTags({
                'action': 'doAddTag',
                'ids': $scope.results,
                'type': 'Contacts',
                'tagNames': _tags
            }, _callback);
        };

        $scope.tagSelect = contactDetailsService.tagSelect;

    }
]);

/**
 * message modal
 */
appCtrlModalsModule.controller('addMessageController', ['$scope', '$rootScope', 'contactService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, actionModalService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        actionModalService.getMessageInfo(contactService.messageEids, false, -1, function (results) {
            var result = results.resultList;

            var recipientArray = [];
            var invalid = 0;
            var unsubscribed = 0;
            angular.forEach(result, function (value, key) {
                var person = ' ' + value.firstName + ' ' + value.lastName;
                if (value.primaryEmail !== null && value.primaryEmail.name !== '') {
                    person = person + ' <' + value.primaryEmail.name + '>';
                } else {
                    invalid++;
                }
                recipientArray.push(person);
            });
            $scope.recipient = recipientArray.join(',');

            var total = result.length;
            if (invalid > 0) {
                $scope.invalid = i18n['JV_CONTACTMODAL__0_OF_1_CONTACT_S_DO_NOT_HAVE_A_VALID_EMAIL_ADRESS'].format(invalid, total);
            }
            if (unsubscribed > 0) {
                $scope.unsubscribed = i18n['JV_CONTACTMODAL__0_OF_1_CONTACT_S_OPTED_OUT_'].format(unsubscribed, total);
            }
            if (invalid > 0 || unsubscribed > 0) {
                $scope.notSent = i18n['JV_CONTACTMODAL_THIS_EMAIL_WILL_NOT_BE_SENT_TO_THEM_'];
            }
        });

        $scope.save = function () {
            $scope.contentError = ($scope.messageContent === '' || $scope.messageContent == null);
            $scope.subjectError = ($scope.messageSubject === '' || $scope.messageSubject == null);
            if (!$scope.contentError && !$scope.subjectError) {
                var messageObj = {};
                messageObj.message = $scope.messageContent;
                messageObj.subject = $scope.messageSubject;
                $rootScope.$broadcast('addMessage', messageObj);
                $scope.close();
            }
        };

    }
]);

/**
 * reusing message modal for seek consent
 */
appCtrlModalsModule.controller('addSeekConsentMessageController', ['$scope', '$rootScope', 'contactService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, actionModalService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $scope.seekConsent.messageTemplates = {};
            $rootScope.$broadcast('uncheckAll');
        };

        actionModalService.getMessageInfo(contactService.messageEids, true, 277, function (results) {
            var result = results.resultList;
            $scope.seekConsent = {};
            $scope.seekConsent.messageTemplates = selectDefaultTemplate(results.messageTemplates);

            var recipientArray = [];
            var invalid = 0;
            var unsubscribed = 0;
            angular.forEach(result, function (value, key) {
                var person = ' ' + value.firstName + ' ' + value.lastName;
                if (value.primaryEmail !== null && value.primaryEmail.name !== '') {
                    person = person + ' <' + value.primaryEmail.name + '>';
                } else {
                    invalid++;
                }
                recipientArray.push(person);
            });
            $scope.recipient = recipientArray.join(',');

            var total = result.length;
            if (invalid > 0) {
                $scope.invalid = i18n['JV_CONTACTMODAL__0_OF_1_CONTACT_S_DO_NOT_HAVE_A_VALID_EMAIL_ADRESS'].format(invalid, total);
            }
            if (unsubscribed > 0) {
                $scope.unsubscribed = i18n['JV_CONTACTMODAL__0_OF_1_CONTACT_S_OPTED_OUT_'].format(unsubscribed, total);
            }
            if (invalid > 0 || unsubscribed > 0) {
                $scope.notSent = i18n['JV_CONTACTMODAL_THIS_EMAIL_WILL_NOT_BE_SENT_TO_THEM_'];
            }
        });

        var selectDefaultTemplate = function (templates) {
            angular.forEach(templates, function (tpl) {
                setTemplateName(tpl);
                if (tpl.isDefault === true) {
                    $scope.seekConsent.messageTpl = tpl;
                    $scope.messageContent = tpl.message;
                    $scope.messageSubject = tpl.subject;
                }
            });
            return templates;
        };

        // setting the template title as combination of template title and locale
        var setTemplateName = function (template) {
            template.name = template.title + ' - ' + template.locale;
        };

        $scope.save = function () {
            $scope.contentError = ($scope.messageContent === '' || $scope.messageContent == null);
            $scope.subjectError = ($scope.messageSubject === '' || $scope.messageSubject == null);
            if (!$scope.contentError && !$scope.subjectError) {
                var messageObj = {};
                messageObj.message = $scope.messageContent;
                messageObj.subject = $scope.messageSubject;
                $rootScope.$broadcast('addSeekConsentMessage', messageObj);
                $scope.close();
            }
        };

    }
]);

/**
 * Add to req confirm modal
 */
appCtrlModalsModule.controller('reqConfirmationController', ['$scope', '$rootScope', 'contactService', 'actionModalService', 'sourceModalAdapter',
    function ($scope, $rootScope, contactService, actionModalService, sourceModalAdapter) {
        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };
        $scope.refresh = function () {
            $scope.close();
        };
    }
]);

/**
 * Select requisition overlay modal controller.
 * @param {Object} $scope
 */
appCtrlModalsModule.controller('SelectRequisitionsController', ['$scope', 'actionModalService', '$rootScope', 'sourceModalAdapter',
    function ($scope, actionModalService, $rootScope, sourceModalAdapter) {
        $scope.query = {};
        // this is the page size, right now backend is not returning it so defaulting it to 10
        $scope.pageCount = 10;
        $scope.page = 0;
        $scope.query.page = 0;
        $scope.totalPages = 0;
        $scope.queryString = '';
        $scope.selectedReq = {
            index: null
        };
        $scope.reqType = null;

        $scope.reqsModalType = [{
                id: '1009',
                text: i18n['JV_CONTACTMODAL_ACTIVE_REQUISITIONS']
            },
            {
                id: '1',
                text: i18n['JV_CONTACTMODAL_OPEN_REQUISITIONS']
            },
            {
                id: '2',
                text: i18n['JV_CONTACTMODAL_CLOSED_REQUISITIONS']
            },
            {
                id: '14',
                text: i18n['JV_CONTACTMODAL_FILLED_REQUISITIONS']
            },
            {
                id: '4',
                text: i18n['JV_CONTACTMODAL_INACTIVE_REQUISITIONS']
            },
            {
                id: '8',
                text: i18n['JV_CONTACTMODAL_ON_HOLD_REQUISITIONS']
            },
            {
                id: '240',
                text: i18n['JV_CONTACTMODAL_SUBMITTED_REQUISITIONS']
            },
            {
                id: '1009',
                text: i18n['JV_CONTACTMODAL_MY_ACTIVE_REQUISITIONS'],
                'mine': true
            },
            {
                id: '1',
                text: i18n['JV_CONTACTMODAL_MY_OPEN_REQUISITIONS'],
                mine: true
            },
            {
                id: '2',
                text: i18n['JV_CONTACTMODAL_MY_CLOSED_REQUISITIONS'],
                mine: true
            },
            {
                id: '4',
                text: i18n['JV_CONTACTMODAL_MY_FILLED_REQUISITIONS'],
                mine: true
            },
            {
                id: '14',
                text: i18n['JV_CONTACTMODAL_MY_INACTIVE_REQUISITIONS'],
                mine: true
            },
            {
                id: '8',
                text: i18n['JV_CONTACTMODAL_MY_ON_HOLD_REQUISITIONS'],
                mine: true
            },
            {
                id: '240',
                text: i18n['JV_CONTACTMODAL_MY_SUBMITTED_REQUISITIONS'],
                mine: true
            }
        ];

        // called by all the actions within requisitions modal.
        function getReqModal() {
            $scope.showLoading = true;
            // Below two properties are needed by the jhire backend to not consider cookie values saved on the req pages.
            $scope.query.refreshGrid = 'refreshGrid';
            $scope.query.searchAllReq = true;
            actionModalService.getRequisition($scope.query, function (results) {
                $scope.results = results;
                $scope.showLoading = false;
            });
        }

        $scope.$watch('reqType', function (newValue, oldValue) {
            if (newValue === oldValue) {
                return;
            }

            $scope.query.page = 0;
            $scope.query.mine = newValue.mine;
            $scope.query.jobStateValue = newValue.id;
            getReqModal();
        }, true);

        $scope.paginate = function (ifForward) {
            if (ifForward && $scope.query.page < ($scope.totalPages - 1)) {
                $scope.page = ++$scope.query.page;
            } else if (!ifForward && $scope.query.page > 0) {
                $scope.page = --$scope.query.page;
            } else {
                return;
            }
            getReqModal();
        };

        $scope.search = function () {
            $scope.query.q = $scope.querystring;
            getReqModal();
        };

        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        $scope.select = function () {

            var obj = $.grep($scope.results.jobs, function (object, index) {
                if (object.EId === $scope.selectedReq.index) {
                    return object;
                }
            });
            //TODO
            $rootScope.$broadcast('addToRequisition', obj[0]);
            //$scope.deferredService.resolve(obj[0]);
            $scope.close();
        };

        $scope.$watch('results', function (newValue, oldValue) {
            $scope.totalPages = Math.ceil($scope.results.jobCount / $scope.pageCount);
        });

    }
]);

/**
 * for email campaign selector modal
 */
appCtrlModalsModule.controller('selectEmailCampaignsController', ['$scope', 'contactService', '$rootScope', 'sourceModalAdapter',
    function ($scope, contactService, $rootScope, sourceModalAdapter) {
        var firstRun = true;

        function search() {
            var args = {
                page: $scope.page,
                keywords: $scope.query,
                status: 'IN_PROGRESS'
            };

            function resetScope(results) {
                $scope.campaigns = results.resultList;
                $scope.start = (results.page * results.pageCount) + 1;
                $scope.end = (results.page + 1) * results.pageCount;
                $scope.totalNumber = results.resultCount;
                $scope.page = results.page;
                $scope.totalPages = Math.ceil($scope.totalNumber / $scope.campaigns.length);
                if (!firstRun) {
                    ($scope._resize || angular.noop)();
                }
                firstRun = false;
            }
            angular.extend(args, {
                type: 'EMAIL',
                hasContentFlag: false
            });
            contactService.getCampaignsNoBroadcast(args, resetScope);
        }

        $scope.query = '';
        $scope.page = 0;
        $scope.selectedCampaign = {
            index: ''
        };

        $scope.$watch('selectedCampaign.index', function (newVal) {
            if (newVal) {
                angular.forEach($scope.campaigns, function (campaign) {
                    if (campaign.eid === newVal) {
                        $scope.campaignObj = campaign;
                    }
                });
            }
        });

        if (!$scope.select) {
            $scope.select = function (campaignObj) {
                $rootScope.$broadcast('addToCampaign', campaignObj);
                $scope.close();
            }
        }

        $scope.close = function () {
            sourceModalAdapter.hideModal();
            $rootScope.$broadcast('uncheckAll');
        };

        $scope.search = function () {
            $scope.page = 0;
            search();
        };

        $scope.paginate = function (forward) {
            if (forward) {
                $scope.page++;
            } else {
                $scope.page--;
            }
            search();
        };

        search();
    }
]);

appCtrlModalsModule.controller('advancedSettingsController', ['$scope', 'contactService', '$window', 'sourceModalAdapter',
    function ($scope, contactService, $window, sourceModalAdapter) {

        var andFacets = [];
        var configurableIds = ['ca', 'col', 'sk', 't', 'pc'];

        $scope.configurableFacets = [];
        $scope.state = {
            saving: false
        };

        $window.scrollTo(0, 0);

        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };

        $scope.save = function () {
            if ($scope.state.saving) {
                return;
            }
            $scope.state.saving = true;
            $scope.results.facets = andFacets;
            contactService.saveAndFacets($scope.results.facets).then(function () {
                window.JV.showDropDownMessage(i18n['JV_CONTACTMODAL_SEARCH_SETTINGS_SAVED_']);
                $scope.close();
                $scope.state.saving = false;
            }, function () {
                window.JV.showDropDownMessageError(i18n['JV_CONTACTMODAL_UNABLE_TO_SAVE_SEARCH_SETTINGS_']);
                $scope.state.saving = false;
            });
        };

        $scope.$watch('configurableFacets', function (facets) {
            if (facets && $scope.results.facets) {
                andFacets = $scope.configurableFacets.filter(function (facet) {
                    return (facet.operation === 'and');
                }).map(function (facet) {
                    return facet.id;
                });
            }
        }, true);

        $scope.$watch('results', function (results) {
            if (results && results.facets) {
                $scope.configurableFacets = results.allFacets.filter(function (facet) {
                    return (configurableIds.indexOf(facet.fieldId) > -1);
                }).map(function (facet) {
                    return {
                        label: facet.fieldDisplayName,
                        id: facet.fieldId,
                        operation: (results.facets.indexOf(facet.fieldId) > -1) ? 'and' : 'or'
                    };
                });
            }
        });

    }
]);

appCtrlModalsModule.controller('assignToController', ['$scope', 'actionModalService', 'i18n', 'sourceModalAdapter',
    function ($scope, actionModalService, i18n, sourceModalAdapter) {

        $scope.state = {
            saving: false
        };

        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };

        $scope.save = function () {
            if ($scope.state.saving) {
                return;
            }
            $scope.state.saving = true;
            actionModalService.assignTo($scope.results, $scope.employee).then(function (res) {
                window.JV.showDropDownMessage(res.data);
                $scope.close();
                $scope.state.saving = false;
            }, function () {
                window.JV.showDropDownMessageError(i18n.TN_ASSIGN_TO_ERROR);
                $scope.state.saving = false;
            });
        };
    }
]);

appCtrlModalsModule.controller('changeStatusController', ['$scope', 'actionModalService', 'i18n', 'sourceModalAdapter',
    function ($scope, actionModalService, i18n, sourceModalAdapter) {
        $scope.state = {
            saving: false
        };

        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };

        $scope.save = function () {
            if ($scope.state.saving) {
                return;
            }
            $scope.state.saving = true;
            actionModalService.changeStatus($scope.results.selected, $scope.selectedStatus).then(function (res) {
                window.JV.showDropDownMessage(res.data);
                $scope.close();
                $scope.state.saving = false;
            }, function () {
                window.JV.showDropDownMessageError(i18n.TN_CHANGE_STATUS_ERROR);
                $scope.state.saving = false;
            });
        };

        $scope.$watch('results', function (results) {
            if (results) {
                $scope.statuses = results.statuses;
            }
        });
    }
]);

appCtrlModalsModule.controller('addTaskController', ['$scope', 'actionModalService', 'i18n', 'sourceModalAdapter',
    function ($scope, actionModalService, i18n, sourceModalAdapter) {

        $scope.state = {
            saving: false
        };

        $scope.close = function () {
            sourceModalAdapter.hideModal();
        };

        $scope.save = function () {
            var task = angular.copy($scope.task);
            if ($scope.state.saving) {
                return;
            }
            $scope.state.saving = true;
            //task.dueDate += 'T00:00:00-08:00'; // add pacific timezone so BE can parse it
            actionModalService.addTask($scope.results, task).then(function (res) {
                window.JV.showDropDownMessage(i18n.TN_ADD_TASK_SUCCESS);
                $scope.close();
                $scope.state.saving = false;
            }, function () {
                window.JV.showDropDownMessageError(i18n.TN_ADD_TASK_ERROR);
                $scope.state.saving = false;
            });
        };

        $scope.datepickerOptions = {
            beforeShow: function () {
                // this class isn't removed for some reason so datepicker never becomes visible,
                // need to manually remove it
                $('#ui-datepicker-div').removeClass('ui-helper-hidden-accessible');
            }
        };

    }
]);


appCtrlModalsModule.controller('addToReqController', ['$scope', '$rootScope',
    function ($scope, $rootScope) {
        //Setting up add to Req modal configs
        var getmodalConfig = function (action) {
            switch (action) {
                case 'addToReq':
                    //Add to Req modal config
                    $scope.addToReqModalConfig = {
                        resetModalOn: 'modals.show',
                        list: {
                            config: {
                                type: 'singleSelect',
                                keyName: 'selectedReqEId',
                                label: i18n['JV_CONTACTMODAL_SELECT_REQUISITION'],
                                tooltip: {
                                    show: false,
                                    text: i18n['JV_CONTACTMODAL_TOOLTIP_TEXT_GOES_HERE']
                                },
                                required: true,
                                errorText: i18n['JV_CONTACTMODAL_PLEASE_SELECT_A_REQUISITION'],
                                emptySearchText: i18n['FORMTEMPLATE_H_NO_RESULTS_FOUND_PLEASE_DO_ANOTHER_SEARCH'],
                                columns: [{
                                        header: i18n['JV_CONTACTMODAL_REQUISITION'],
                                        show: true,
                                        key: ['title'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['JV_CONTACTMODAL_ID'],
                                        show: true,
                                        key: ['requisitionId']
                                    },
                                    {
                                        header: i18n['JV_CONTACTMODAL_STATUS'],
                                        show: true,
                                        key: ['jobState']
                                    },
                                    {
                                        header: i18n['JV_CONTACTMODAL_COMPANY'],
                                        show: 'showCompany',
                                        key: ['subsidiary.name']
                                    },
                                    {
                                        header: i18n['JV_CONTACTMODAL_CATEGORY'],
                                        show: true,
                                        key: ['category.name'],
                                        ellipsis: {
                                            set: true
                                        }
                                    },
                                    {
                                        header: i18n['JV_CONTACTMODAL_LOCATION'],
                                        show: true,
                                        key: ['location.name'],
                                        ellipsis: {
                                            set: true
                                        },
                                        tooltipShow: 'jobLocations',
                                        tooltipTriggerLength: 'jobLocations',
                                        tooltipTriggerClass: 'italic',
                                        tooltipBodyList: 'jobLocations',
                                        tooltipBodyListId: ['name']
                                    }
                                ]
                            },
                            get: $scope.listGetObject,
                            post: {
                                callBack: $scope.addToReqCallback,
                                button: {
                                    label: i18n['JV_CONTACTMODAL_SELECT'],
                                    type: 'button',
                                    classNames: ['blue-btn', 'float-right'],
                                    id: 'addToReq-btn'
                                }
                            },
                            filters: [{
                                    label: i18n['JV_CONTACTMODAL_STATUS'],
                                    ghostText: i18n['JV_CONTACTMODAL_ALL'],
                                    width: 'w160',
                                    allowClear: true,
                                    data: $scope.statusFilter,
                                    keyName: 'reqsStatusFilter',
                                    defaultTo: '{"key":1,"mine":false,"name":"Open"}'
                                },
                                {
                                    label: i18n['JV_CONTACTMODAL_CATEGORIES'],
                                    ghostText: i18n['JV_CONTACTMODAL_ALL'],
                                    width: 'w260',
                                    allowClear: true,
                                    data: $scope.categoriesFilter,
                                    keyName: 'reqsCategoryFilter'
                                }

                            ],
                            search: {
                                label: i18n['JV_CONTACTMODAL_SEARCH'],
                                placeholder: i18n['FORMTEMPLATE_H_SEARCH_BY_REQUISITION_OR_ID'],
                                get: {
                                    url: '/jhire/action/requisitions?'
                                }
                            }
                        }
                    };
                    return $scope.addToReqModalConfig;
                default:
                    // default
            }
        };
        $scope.$watch('results', function (newValue) {
            if (angular.isDefined(newValue)) {
                $scope.statusFilter = $scope.results.allStatusFilter.optionValues;
                $scope.categoriesFilter = $scope.results.filters.Categories;
            }
            setupFormTemplateConfig('addToReq');

        });

        $scope.addToReqCallback = function (data) {
            $rootScope.$broadcast('REQUISITTION_SELECTED_ID', data);
        };

        var setupFormTemplateConfig = function (action) {
            $scope.listGetObject = {
                url: '/jhire/action/requisitions?',
                params: {
                    page: '0',
                    q: '',
                    maxResults: '10',
                    mine: false
                },
                responseKey: 'jobs'
            };
            $scope.formTemplateConfig = getmodalConfig(action);
        };
        $scope.flags = {};
    }
]);